import type { TRootState } from 'store';
import type { ITableSelector } from 'interfaces/Table/selector.interface';
import { createTableSelectorSlice } from 'redux/table/helper/createTableSelector.slice';
import {
  itemsPerPageDefault,
  currentPageDefault,
  createdAtSortingDefault,
} from 'redux/table/consts/tableDefaults.consts';

export const companyDocumentsSlice = createTableSelectorSlice(
  'paginatedCompanyDocuments',
  currentPageDefault,
  itemsPerPageDefault,
  createdAtSortingDefault
);

const { actions, reducer } = companyDocumentsSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
  setInitialFiltersSet,
  setMenuColumnList,
} = actions;

export const paginatedCompanyDocumentsSelector = (
  state: TRootState
): ITableSelector => state.tableCompanyDocuments;

export default reducer;
